import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

type LocationProviderProps = {
  children?: React.ReactNode;
};

const LocationContext = React.createContext<{
  currentLocation?: string;
  previousLocation?: string;
}>({
  currentLocation: undefined,
  previousLocation: undefined,
});

export const LocationProvider = ({ children }: LocationProviderProps) => {
  const location = useLocation();
  const [previousLocation, setPreviousLocation] = useState<
    string | undefined
  >();
  const [currentLocation, setCurrentLocation] = useState<string | undefined>();

  useEffect(() => {
    if (currentLocation) {
      setPreviousLocation(currentLocation);
    }

    setCurrentLocation(location.pathname + location.search);
  }, [location.pathname, location.search]);

  const contextValue = useMemo(
    () => ({ currentLocation, previousLocation }),
    [currentLocation, previousLocation]
  );

  return (
    <LocationContext.Provider value={contextValue}>
      {children}
    </LocationContext.Provider>
  );
};

export function useLocationContext() {
  return useContext(LocationContext);
}
